import React, { useState } from "react";
import { Box, TextField, Button, Typography, CircularProgress, Alert } from "@mui/material";
import { saveUsername } from "../utils/api";
import { t } from "@lingui/macro";

const validateUsername = (username) => {
  if (!username || username.trim().length < 3) {
    return t`Username must be at least 3 characters long.`;
  }
  return "";
};

const ChooseUsernameScreen = () => {
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState("");

  const handleSave = async () => {
    const validationError = validateUsername(username);
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      setLoading(true);
      setError("");
      await saveUsername(username.trim());
      setNotification(t`Username saved successfully!`);
      // Reload to ensure updated user context
      setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      if (err.code === "username_taken") {
        setError(t`This username is already taken.`);
      } else if (err.code === "invalid_format") {
        setError(t`Invalid username format.`);
      } else if (err.code === "not_allowed") {
        setError(t`You cannot change your username once it is set.`);
      } else {
        setError(t`Unexpected error. Please try again.`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: 350,
        margin: "auto",
        textAlign: "center",
        mt: 4,
        p: 3,
        border: "1px solid #ccc",
        borderRadius: 2,
        position: "relative",
      }}
    >
      <Typography variant="h5" gutterBottom>
        {t`Choose Your Username`}
      </Typography>

      {notification && <Alert severity="success" sx={{ mb: 2 }}>{notification}</Alert>}

      <TextField
        fullWidth
        margin="normal"
        label={t`Username`}
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        error={!!error}
        helperText={error}
      />

      <Button
        variant="contained"
        fullWidth
        onClick={handleSave}
        sx={{ mt: 2 }}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : t`Save Username`}
      </Button>
    </Box>
  );
};

export default ChooseUsernameScreen;
